import { render, staticRenderFns } from "./ShowUpload.vue?vue&type=template&id=4ec58b83&scoped=true&"
import script from "./ShowUpload.vue?vue&type=script&lang=ts&"
export * from "./ShowUpload.vue?vue&type=script&lang=ts&"
import style0 from "./ShowUpload.vue?vue&type=style&index=0&id=4ec58b83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec58b83",
  null
  
)

export default component.exports